import {
  Col,
  Table,
  Tag,
  Space,
  Modal,
  Tooltip,
  Popconfirm,
  Select,
  Input,
  Button,
  Upload,
} from "antd";
import { memo, useEffect, useState } from "react";
import Historymodal from "./Historymodal";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getchatrecords, historyrecordlist } from "../../api/accountAction";
import {
  capitalizeWords,
  formatDate,
  generateRandomFourDigitNumber,
} from "../../customhook/CustomHoom";
import { Icon } from "@iconify/react";
import MarkdownToJSX from "markdown-to-jsx";
import { gethistoryrecordlist } from "../Auth/Publicauth";
import MainStyle from "../../../MainStyle.scss";
import PopConfirmQa from "./PopConfirmQa";
import { Row } from "react-bootstrap";
import AWS from "aws-sdk";
import preloader from "../../../assets/loader/pre_loader.gif";

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: process.env.REACT_APP_AWS_REGION,
  signatureVersion: process.env.REACT_APP_AWS_SIGNATURE_VERSION,
});
const Chattablemain = () => {
  const s3 = new AWS.S3();
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedItem, setSelectedItem] = useState("transcript");
  const [tablerecord, setTablerecord] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [preloaderstatus, setpreloaderstatus] = useState(false);
  const [historyopen, setHistoryOpen] = useState(false);
  const [records, setRecords] = useState([]);
  const { avatardetails } = useSelector((state) => state.chat);
  const [fileModalOpen, setFileModalOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [tablecolumns, setTableColums] = useState([
    {
      title: "Date&Time",
      dataIndex: "datetime",
      key: "datetime",
      render: (text) => (
        <span style={{ whiteSpace: "nowrap" }}>{formatDate(text)}</span>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => capitalizeWords(text),
      align: "center",
    },
    {
      title: "Convo Type",
      dataIndex: "typeofconversation",
      key: "typeofconversation",
      align: "center",

      render: (_, { typeofconversation }) => (
        <>
          {typeofconversation != null && (
            <>
              {typeofconversation.split(",").map((tag) => {
                let color;
                if (tag.trim() === "voice") {
                  color = "purple";
                } else if (tag.trim() === "chat") {
                  color = "blue";
                } else {
                  color = "red";
                }
                return (
                  <Tag color={color} key={tag.trim()}>
                    {tag.trim()}
                  </Tag>
                );
              })}
            </>
          )}
        </>
      ),
      onHeaderCell: () => ({
        style: {
          whiteSpace: "normal",
          wordWrap: "break-word",
          textAlign: "center",
        },
      }),
    },
    {
      title: "Sentiment",
      dataIndex: "sentiment",
      key: "sentiment",
      align: "center",
      render: (sentiment, record) => {
        let iconColor, iconName, textColor;
        switch (sentiment) {
          case "Positive":
            iconColor = "#0BB852";
            iconName = "mdi:smiley";
            textColor = "#0BB852";
            break;
          case "Neutral":
            iconColor = "#FFC400";
            iconName = "ph:smiley-meh-fill";
            textColor = "#FFC400";
            break;
          case "Negative":
            iconColor = "#FF2441";
            iconName = "ion:sad";
            textColor = "#FF2441";
            break;
          default:
            iconColor = "black";
            iconName = "ph:smiley-fill";
        }

        return (
          <>
            <div style={{ whiteSpace: "nowrap" }}>
              <Popconfirm
                className="record-dashboard-popup"
                placement="top"
                title=""
                description=<MarkdownToJSX>
                  {record.sentiment_explanation}
                </MarkdownToJSX>
                footer={false}
                okText=""
                cancelText=""
                cancelButtonProps={{ style: { display: "none" } }}
                okButtonProps={{ style: { display: "none" } }}
              >
                {sentiment && (
                  <>
                    <span>
                      <Icon
                        icon={iconName}
                        style={{ color: iconColor, fontSize: "24px" }}
                        className="cursor"
                      />
                    </span>
                    <span
                      style={{ color: textColor }}
                      className="smiley-text cursor"
                    >
                      {capitalizeWords(sentiment)}
                    </span>
                  </>
                )}
              </Popconfirm>
            </div>
          </>
        );
      },
    },
    {
      title: "Summary",
      dataIndex: "summary",
      key: "summary",
      align: "center",
      render: (summary, record) => {
        const truncatedSummary =
          summary?.length > 4 ? summary.slice(0, 5) + "..." : summary;
        return (
          <>
            {summary && (
              <div style={{ whiteSpace: "nowrap" }}>
                <Popconfirm
                  className="record-dashboard-popup"
                  placement="top"
                  title=""
                  description=<MarkdownToJSX>{summary}</MarkdownToJSX>
                  footer={false}
                  okText=""
                  cancelText=""
                  cancelButtonProps={{ style: { display: "none" } }}
                  okButtonProps={{ style: { display: "none" } }}
                >
                  <span>
                    <Icon
                      icon="fluent:notepad-edit-20-regular"
                      style={{ color: "#fff", fontSize: "24px" }}
                      className="cursor"
                    />
                  </span>{" "}
                  <span>{truncatedSummary}</span>
                </Popconfirm>
              </div>
            )}
          </>
        );
      },
    },
    {
      title: "Opportunity",
      dataIndex: "lead",
      key: "lead",
      align: "center",
      render: (lead, record) => {
        let iconColor, iconName, textColor;

        switch (lead) {
          case "Yes":
            iconColor = "#0BB852";
            iconName = "mdi:smiley";
            textColor = "#0BB852";
            break;
          case "Neutral":
            iconColor = "#FFC400";
            iconName = "ph:smiley-meh-fill";
            textColor = "#FFC400";
            break;
          case "No":
            iconColor = "red";
            iconName = "ion:sad";
            textColor = "red";
            break;
          default:
            iconColor = "#fff";
            iconName = "ph:smiley-fill";
        }

        return (
          <>
            <div style={{ whiteSpace: "nowrap" }}>
              <Popconfirm
                className="record-dashboard-popup"
                placement="top"
                title=""
                description=<MarkdownToJSX>
                  {record.lead_explanation}
                </MarkdownToJSX>
                footer={false}
                okText=""
                cancelText=""
                cancelButtonProps={{ style: { display: "none" } }}
                okButtonProps={{ style: { display: "none" } }}
              >
                {lead === "Yes" && (
                  <>
                    <span>
                      {" "}
                      <Tag color="green">{capitalizeWords(lead)}</Tag>
                    </span>
                  </>
                )}
                {lead === "No" && (
                  <>
                    <span>
                      {" "}
                      <Tag color="red">{capitalizeWords(lead)}</Tag>
                    </span>
                  </>
                )}
              </Popconfirm>
            </div>
          </>
        );
      },

      onHeaderCell: () => ({
        style: {
          whiteSpace: "normal",
          wordWrap: "break-word",
          textAlign: "center",
        },
      }),
    },

    {
      title: "Action",
      dataIndex: "action_to_be_taken",
      key: "action_to_be_taken",
      align: "center",
      render: (summary, record) => {
        return (
          <>
            {summary != null && (
              <div style={{ whiteSpace: "nowrap" }}>
                <Popconfirm
                  className="record-dashboard-popup"
                  placement="top"
                  title=""
                  description=<MarkdownToJSX>{summary}</MarkdownToJSX>
                  footer={false}
                  okText=""
                  cancelText=""
                  cancelButtonProps={{ style: { display: "none" } }}
                  okButtonProps={{ style: { display: "none" } }}
                >
                  <span>
                    <Icon
                      icon="eos-icons:role-binding-outlined"
                      style={{ color: "#fff", fontSize: "24px" }}
                      className="cursor"
                    />
                  </span>
                </Popconfirm>
              </div>
            )}
          </>
        );
      },
    },
    {
      title: "Handedoff",
      dataIndex: "handed_off",
      key: "handed_off",
      align: "center",
      render: (handed_off, record) => {
        let iconColor, iconName, textColor;
        switch (handed_off) {
          case "Negative":
            iconColor = "red";
            iconName = "ion:sad";
            textColor = "red";
            break;
          case "Positive":
            iconColor = "#0BB852";
            iconName = "mdi:smiley";
            textColor = "#0BB852";
            break;

          default:
            iconColor = "#fff";
            iconName = "ph:smiley-fill";
        }

        return (
          <>
            <div style={{ whiteSpace: "nowrap" }}>
              <Popconfirm
                className="record-dashboard-popup"
                placement="top"
                title=""
                description=<MarkdownToJSX>
                  {record.handed_off_explanation}
                </MarkdownToJSX>
                footer={false}
                okText=""
                cancelText=""
                cancelButtonProps={{ style: { display: "none" } }}
                okButtonProps={{ style: { display: "none" } }}
              >
                {handed_off && (
                  <>
                    <span>
                      <Icon
                        icon={iconName}
                        style={{ color: iconColor, fontSize: "24px" }}
                        className="cursor"
                      />
                    </span>{" "}
                    <span
                      style={{ color: textColor }}
                      className="smiley-text cursor"
                    >
                      {capitalizeWords(handed_off)}
                    </span>
                  </>
                )}
              </Popconfirm>
            </div>
          </>
        );
      },
    },
    // {
    //   title: "QA Check",
    //   dataIndex: "qa_status",
    //   key: "qa_status",
    //   render: (handed_off, record) => {
    //     let iconColor, iconName, textColor;
    //     switch (handed_off) {
    //       case "Incomplete":
    //         iconColor = "red";
    //         iconName = "ion:sad";
    //         textColor = "red";
    //         break;
    //       case "Completed":
    //         iconColor = "#0BB852";
    //         iconName = "mdi:smiley";
    //         textColor = "#0BB852";
    //         break;

    //       default:
    //         iconColor = "#fff";
    //         iconName = "ph:smiley-fill";
    //     }

    //     return (
    //       <>
    //         <div style={{ whiteSpace: "nowrap" }}>
    //           <Popconfirm
    //             className="record-dashboard-popup"
    //             placement="top"
    //             title=""
    //             description=<PopConfirmQa
    //               content={record.qa_content ? record.qa_content : ""}
    //             />
    //             footer={false}
    //             okText=""
    //             cancelText=""
    //             cancelButtonProps={{ style: { display: "none" } }}
    //             okButtonProps={{ style: { display: "none" } }}
    //           >
    //             {handed_off && (
    //               <>
    //                 <span>
    //                   <Icon
    //                     icon={iconName}
    //                     style={{ color: iconColor, fontSize: "24px" }}
    //                     className="cursor"
    //                   />
    //                 </span>{" "}
    //                 <span
    //                   style={{ color: textColor }}
    //                   className="smiley-text cursor"
    //                 >
    //                   {capitalizeWords(handed_off)}
    //                 </span>
    //               </>
    //             )}
    //           </Popconfirm>
    //         </div>
    //       </>
    //     );
    //   },
    // },
    {
      title: " ",
      key: "action",
      align: "center",
      render: (text, record, index) => (
        <Space size="middle">
          <a
            className="view-more"
            onClick={() => handlehistory(record)}
            style={{ whiteSpace: "nowrap", textDecoration: "underline" }}
          >
            View more
          </a>
        </Space>
      ),
      onHeaderCell: () => ({ style: { whiteSpace: "nowrap" } }),
    },
  ]);
  const [voicetablecolumns, setVoiceTableColums] = useState([
    {
      title: "Date&Time",
      dataIndex: "datetime",
      key: "datetime",
      render: (text) => (
        <span style={{ whiteSpace: "nowrap" }}>{formatDate(text)}</span>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => capitalizeWords(text),
    },
    {
      title: "Convo Type",
      dataIndex: "typeofconversation",
      key: "typeofconversation",
      align: "center",

      render: (_, { typeofconversation }) => (
        <>
          {typeofconversation != null && (
            <>
              {typeofconversation.split(",").map((tag) => {
                let color;
                if (tag.trim() === "voice") {
                  color = "purple";
                } else if (tag.trim() === "chat") {
                  color = "blue";
                } else {
                  color = "red";
                }
                return (
                  <Tag color={color} key={tag.trim()}>
                    {tag.trim()}
                  </Tag>
                );
              })}
            </>
          )}
        </>
      ),
      onHeaderCell: () => ({
        style: {
          whiteSpace: "normal",
          wordWrap: "break-word",
          textAlign: "center",
        },
      }),
    },
    {
      title: "Sentiment",
      dataIndex: "sentiment",
      key: "sentiment",
      render: (sentiment, record) => {
        let iconColor, iconName, textColor;
        switch (sentiment) {
          case "Positive":
            iconColor = "#0BB852";
            iconName = "mdi:smiley";
            textColor = "#0BB852";
            break;
          case "Neutral":
            iconColor = "#FFC400";
            iconName = "ph:smiley-meh-fill";
            textColor = "#FFC400";
            break;
          case "Negative":
            iconColor = "#FF2441";
            iconName = "ion:sad";
            textColor = "#FF2441";
            break;
          default:
            iconColor = "black";
            iconName = "ph:smiley-fill";
        }

        return (
          <>
            <div style={{ whiteSpace: "nowrap" }}>
              <Popconfirm
                className="record-dashboard-popup"
                placement="top"
                title=""
                description=<MarkdownToJSX>
                  {record.sentiment_explanation}
                </MarkdownToJSX>
                footer={false}
                okText=""
                cancelText=""
                cancelButtonProps={{ style: { display: "none" } }}
                okButtonProps={{ style: { display: "none" } }}
              >
                {sentiment && (
                  <>
                    <span>
                      <Icon
                        icon={iconName}
                        style={{ color: iconColor, fontSize: "24px" }}
                        className="cursor"
                      />
                    </span>
                    <span
                      style={{ color: textColor }}
                      className="smiley-text cursor"
                    >
                      {capitalizeWords(sentiment)}
                    </span>
                  </>
                )}
              </Popconfirm>
            </div>
          </>
        );
      },
    },
    {
      title: "Summary",
      dataIndex: "summary",
      key: "summary",
      render: (summary, record) => {
        const truncatedSummary =
          summary?.length > 4 ? summary.slice(0, 5) + "..." : summary;
        return (
          <>
            {summary && (
              <div style={{ whiteSpace: "nowrap" }}>
                <Popconfirm
                  className="record-dashboard-popup"
                  placement="top"
                  title=""
                  description=<MarkdownToJSX>{summary}</MarkdownToJSX>
                  footer={false}
                  okText=""
                  cancelText=""
                  cancelButtonProps={{ style: { display: "none" } }}
                  okButtonProps={{ style: { display: "none" } }}
                >
                  <span>
                    <Icon
                      icon="fluent:notepad-edit-20-regular"
                      style={{ color: "#fff", fontSize: "24px" }}
                      className="cursor"
                    />
                  </span>{" "}
                  <span>{truncatedSummary}</span>
                </Popconfirm>
              </div>
            )}
          </>
        );
      },
    },
    {
      title: "Opportunity",
      dataIndex: "lead",
      key: "lead",
      align: "center",
      render: (lead, record) => {
        let iconColor, iconName, textColor;

        switch (lead) {
          case "Yes":
            iconColor = "#0BB852";
            iconName = "mdi:smiley";
            textColor = "#0BB852";
            break;
          case "Neutral":
            iconColor = "#FFC400";
            iconName = "ph:smiley-meh-fill";
            textColor = "#FFC400";
            break;
          case "No":
            iconColor = "red";
            iconName = "ion:sad";
            textColor = "red";
            break;
          default:
            iconColor = "#fff";
            iconName = "ph:smiley-fill";
        }

        return (
          <>
            <div style={{ whiteSpace: "nowrap" }}>
              <Popconfirm
                className="record-dashboard-popup"
                placement="top"
                title=""
                description=<MarkdownToJSX>
                  {record.lead_explanation}
                </MarkdownToJSX>
                footer={false}
                okText=""
                cancelText=""
                cancelButtonProps={{ style: { display: "none" } }}
                okButtonProps={{ style: { display: "none" } }}
              >
                {lead === "Yes" && (
                  <>
                    <span>
                      {" "}
                      <Tag color="green">{capitalizeWords(lead)}</Tag>
                    </span>
                  </>
                )}
                {lead === "No" && (
                  <>
                    <span>
                      {" "}
                      <Tag color="red">{capitalizeWords(lead)}</Tag>
                    </span>
                  </>
                )}
              </Popconfirm>
            </div>
          </>
        );
      },

      onHeaderCell: () => ({
        style: {
          whiteSpace: "normal",
          wordWrap: "break-word",
          textAlign: "center",
        },
      }),
    },
    {
      title: "Action",
      dataIndex: "action_to_be_taken",
      key: "action_to_be_taken",
      render: (summary, record) => {
        return (
          <>
            {summary != null && (
              <div style={{ whiteSpace: "nowrap" }}>
                <Popconfirm
                  className="record-dashboard-popup"
                  placement="top"
                  title=""
                  description=<MarkdownToJSX>{summary}</MarkdownToJSX>
                  footer={false}
                  okText=""
                  cancelText=""
                  cancelButtonProps={{ style: { display: "none" } }}
                  okButtonProps={{ style: { display: "none" } }}
                >
                  <span>
                    <Icon
                      icon="eos-icons:role-binding-outlined"
                      style={{ color: "#fff", fontSize: "24px" }}
                      className="cursor"
                    />
                  </span>
                </Popconfirm>
              </div>
            )}
          </>
        );
      },
    },
    {
      title: "QA Check",
      dataIndex: "qa_status",
      key: "qa_status",
      render: (handed_off, record) => {
        let iconColor, iconName, textColor;
        switch (handed_off) {
          case "Incomplete":
            iconColor = "red";
            iconName = "ion:sad";
            textColor = "red";
            break;
          case "Completed":
            iconColor = "#0BB852";
            iconName = "mdi:smiley";
            textColor = "#0BB852";
            break;

          default:
            iconColor = "#fff";
            iconName = "ph:smiley-fill";
        }

        return (
          <>
            <div style={{ whiteSpace: "nowrap" }}>
              <Popconfirm
                className="record-dashboard-popup"
                placement="top"
                title=""
                description=<PopConfirmQa content={record.qa_content} />
                footer={false}
                okText=""
                cancelText=""
                cancelButtonProps={{ style: { display: "none" } }}
                okButtonProps={{ style: { display: "none" } }}
              >
                {handed_off && (
                  <>
                    <span>
                      <Icon
                        icon={iconName}
                        style={{ color: iconColor, fontSize: "24px" }}
                        className="cursor"
                      />
                    </span>{" "}
                    <span
                      style={{ color: textColor }}
                      className="smiley-text cursor"
                    >
                      {capitalizeWords(handed_off)}
                    </span>
                  </>
                )}
              </Popconfirm>
            </div>
          </>
        );
      },
    },
    {
      title: " ",
      key: "action",
      render: (text, record, index) => (
        <Space size="middle">
          <a
            className="view-more"
            onClick={() => handlehistory(record)}
            style={{ whiteSpace: "nowrap", textDecoration: "underline" }}
          >
            View more
          </a>
        </Space>
      ),
      onHeaderCell: () => ({ style: { whiteSpace: "nowrap" } }),
    },
  ]);

  const items = [
    {
      label: "Date",
      value: "date",
    },
    {
      label: "Transcript",
      value: "transcript",
    },
  ];

  const { id } = useParams();
  let timer;
  const stopTimer = () => {
    clearInterval(timer);
  };

  const handleFileUpload = (event) => {
    const files = selectedFiles.map((fileInfo) => ({
      file: fileInfo,
    }));
    const selectedFile = files;
    // setFileUpload(selectedFile);
    handlefileOk(selectedFile);
    setFileModalOpen(false);
    setSelectedFiles([]);
  };
  const handlefileOk = (selectedFile) => {
    const uniqueID = generateUniqueID();
    const params = selectedFile.map((fileDetail) => ({
      Bucket: "1ch-cci-audio-input-bucket",
      Key: `${uniqueID}/${fileDetail.file.name}`,
      Body: fileDetail.file.originFileObj,
    }));
    stopTimer();
    handleAWSFileUpload(params, uniqueID);
  };
  function generateUniqueID() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const randomFourDigitNumber = generateRandomFourDigitNumber();
    return `${year}${month}${day}-${randomFourDigitNumber}`;
  }
  const handleAWSFileUpload = async (params, uniqueID) => {
    try {
      const uploadPromises = params.map(async (param) => {
        await s3.upload(param).promise();
      });

      // setTimeout(() => {
      //   dispatch(getEmbeddingfile(input))
      //     .unwrap()
      //     .then(({ data }) => {

      //     })
      //     .catch((err) => {
      //       handleNoResponse(uniqueID);
      //     });
      // }, 2000);
    } catch (error) {
      console.error("Error uploading files to S3:", error);
    }
  };

  const handlehistory = (record) => {
    setRecords(record);
    setHistoryOpen(true);
  };
  const handleCancel = () => {
    setHistoryOpen(false);
    setFileModalOpen(false);
  };
  const handleItemClick = (item) => {
    setSelectedItem(item);
  };

  useEffect(() => {
    setpreloaderstatus(true);
    dispatch(getchatrecords(id))
      .unwrap()
      .then(({ data }) => {
        console.log(JSON.parse(data.aivolvex_control_plane));
        const table = JSON.parse(data.aivolvex_control_plane).map((datas) => {
          return {
            service: datas.service,
            category: datas.category,
            language: datas.language,
            name: datas.user_name,
            email: datas.email,
            handed_off: datas.handed_off,
            typeofconversation: datas.type_of_conversation,
            handed_off_explanation: datas.handed_off_explanation,
            phone: datas.mobile,
            datetime: datas.date_time,
            sentiment: datas.sentiment,
            lead_explanation: datas.lead_explanation,
            sentiment_explanation: datas.sentiment_explanation,
            conversation_id: datas.conversation_id,
            summary: datas.summary,
            lead: datas.lead,
            action_to_be_taken: datas.action_to_be_taken,
            email_content: datas.email_content,
            url: datas.url,
            job_description: datas.job_description,
            selection_status: datas.selection_status,
            qa_status: datas.qa_status,
            score: datas.score,
            qa_content: datas.qa_content,
          };
        });
        setTablerecord(table);
        setpreloaderstatus(false);
      })
      .catch((err) => console.log(err));
    setpreloaderstatus(false);
  }, [id]);
  return (
    <div className="table-container">
      {/* <Row
        gutter={[16, 16]}
        className="table-options d-flex justify-content-end"
      >
        <Col>
          <Row className="recent-prompt-search">
            <div className="recent-search">
              <Col>
                <Select
                  defaultValue={selectedItem}
                  className="recent-search-dropdown"
                  onChange={handleItemClick}
                  options={items}
                />
              </Col>
              <Col className="recent-search-input-mobile">
                <Input
                  placeholder="Search"
                  suffix={
                    <Icon
                      icon="material-symbols:search"
                      className="icon-size"
                    />
                  }
                  className="recent-search-input "
                  onChange={(e) => setSearchQuery(e.target.value)}
                  value={searchQuery}
                />
              </Col>
            </div>
          </Row>
        </Col>
      </Row> */}

      <Col
        xs={24}
        sm={24}
        md={24}
        lg={24}
        xl={24}
        className="dashboard-board-background-table mobile-background"
      >
        {preloaderstatus ? (
          <>
            <Col span={24}>
              <div className="aivolvex-sub-loader fh-100">
                <img src={preloader} width="20%" />
              </div>
            </Col>
          </>
        ) : (
          <Table
            dataSource={tablerecord}
            pagination={{ pageSize: 6 }}
            columns={
              // avatardetails.chat_type == "voice"
              //   ? voicetablecolumns
              // :
              tablecolumns
            }
            scroll={{ x: 1500 }}
            className="recent-prompts-table"
          />
        )}
      </Col>
      <Modal
        open={historyopen}
        footer={false}
        onCancel={handleCancel}
        className="report-table-modal"
        width={1000}
      >
        <Historymodal records={records} />
      </Modal>
    </div>
  );
};
export default Chattablemain;
